import { render } from "./IgrnCreate.vue?vue&type=template&id=fd5df716&scoped=true"
import script from "./IgrnCreate.vue?vue&type=script&lang=js"
export * from "./IgrnCreate.vue?vue&type=script&lang=js"

import "./IgrnCreate.vue?vue&type=style&index=0&id=fd5df716&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5df716"]])

export default __exports__